<template>
  <v-card>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="3" class="mr-4">
          <v-form>
            <v-text-field
              v-if="!rooftopModel.default_rooftop"
              v-model="rooftopModel.name"
              :rules="vruleFieldRequired"
              label="Name"
              :readonly="rooftopModel.default_rooftop"
              required
            />
             <v-text-field
               v-model="rooftopPhone"
               v-mask="'###-###-####'"
               label="Phone"
               type="tel"
               :rules="vruleFieldRequired"
               required
            >
            </v-text-field>

            <v-select
              v-model="rooftopModel.time_zone"
              :items="timezones"
              label="Time Zone"
              :rules="vruleFieldRequired"
              required
            >
            </v-select>
          </v-form>
        </v-col>

        <v-col cols="3" class="mr-4">
          <v-form>
            <v-text-field
              v-model="rooftopModel.address_line_1"
              label="Address Line 1"
              :rules="vruleFieldRequired"
              required
            />
            <v-text-field
              v-model="rooftopModel.address_line_2"
              label="Address Line 2"
            />
            <v-text-field
              v-model="rooftopModel.city"
              label="City"
              :rules="vruleFieldRequired"
              required
            />

            <v-select
              v-model="rooftopModel.state"
              :items="states"
              label="State"
              :rules="vruleFieldRequired"
              required
            >
            </v-select>

            <v-text-field
              v-model="rooftopModel.postal_code"
              label="Postal Code"
              :rules="vruleFieldRequired"
              required
            />
          </v-form>
        </v-col>
        <v-col cols="4">
          <v-card flat>
            <v-card-text>
              <div id="rooftopModelMap" v-if="rooftopModel.latitude">
                <dio-map
                  :latitude="rooftopModel.latitude"
                  :longitude="rooftopModel.longitude"
                  :show-settings="false"
                  max-height="310px"
                ></dio-map>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
    </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import validationMixin from '@/validators/validations_mixin'
import { StatesForSelect } from '@/utils/us_states'
import Map from '@/components/map/Map'
import { prop } from 'ramda'

export default {
  name: 'rooftop-detail',
  mixins: [validationMixin],
  components: {
    [Map.name]: Map
  },
  props: {
    value: {
      required: true,
      type: Object
    }
  },
  data: function () {
    return {
      timezones: [
        'Eastern Time (US & Canada)',
        'Central Time (US & Canada)',
        'Mountain Time (US & Canada)',
        'Pacific Time (US & Canada)',
        'Alaska',
        'Hawaii'
      ],
      states: StatesForSelect
    }
  },
  computed: {
    rooftopPhone: {
      get: function () {
        return prop('phone', this.rooftopModel)
      },
      set: function (val) {
        this.$set(this.rooftopModel, 'phone', val)
      }
    },
    rooftopModel: {
      get: function () {
        return this.value
      },
      set: function (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
  }
}
</script>
